import { Component} from 'vue-property-decorator';
import { LoadData } from '@/app/mixins/load-data.mixin';

@Component
export default class App extends LoadData {
  created() {
    this.init(this.initCallback);
  }
}
